import { LightbulbGroupOffIcon } from './LightbulbGroupOffIcon';

/**
 * author: Michael Irigoyen
 * id CA2B5020-40AD-44C1-8868-F14927FCD535
 * name lightbulb-group-off
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-group-off.svg
 * tags
 * - Home Automation 
 */
export const BulbGroupOffIcon = LightbulbGroupOffIcon;
export default BulbGroupOffIcon